import React from "react";
import api from "../../../api/axios";
import Swal from "sweetalert2";

/**
 * Reusable layout matching your screenshot:
 * left: main card
 * right: downloads / quick links
 */
export default function ReportPageLayout({
  title,
  period,
  children,
  rightSide,
}) {
  /* =============================
      DOWNLOAD CONSOLIDATED PDF
  ============================== */

  const formatPeriodLabel = (p) => {
    if (!p) return "";
    try {
      const [y, m] = p.split("-");
      const date = new Date(`${y}-${m}-01`);
      return date.toLocaleString("en-IN", { month: "long", year: "numeric" });
    } catch {
      return p;
    }
  };
  const downloadConsolidated = async () => {
    if (!period || period.trim() === "") {
      Swal.fire("Missing Month", "Please select a month", "warning");
      return;
    }

    try {
      const response = await api.get(`/hrms/prms/reports/consolidated`, {
        params: { period },
        responseType: "blob",
      });

      const fileURL = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", `consolidated_report_${period}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      Swal.fire("Error", "Unable to download consolidated report.", "error");
    }
  };

  return (
    <div style={{ background: "#eef6fd", minHeight: "100vh" }}>
      <div className="container py-4">
        {/* ======= HEADER ======= */}
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            <h3 className="fw-bold">{title}</h3>
            <p className="text-muted m-0">
              {period ? `Period: ${formatPeriodLabel(period)}` : "No month selected"}
            </p>
          </div>

          <div className="d-flex gap-2">
            <button className="btn btn-outline-secondary">Back to Home</button>

            <button className="btn btn-primary" onClick={downloadConsolidated}>
              <i className="bi bi-download me-1"></i>
              Download Consolidated Report
            </button>
          </div>
        </div>

        {/* ======= LAYOUT ======= */}
        <div className="row mt-3">
          {/* LEFT CONTENT */}
          <div className="col-lg-8 mb-3">
            <div className="bg-white shadow-sm rounded p-4">{children}</div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="col-lg-4">
            <div className="bg-white shadow-sm rounded p-4">{rightSide}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
